import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full bg-crema py-10 md:py-24 px-6 lg:px-12 overflow-hidden" data-id="element-177">
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-[58%_42%] gap-12 lg:gap-8 items-center" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-start" data-id="element-179">
          <div className="bg-navy/10 border border-navy rounded-full px-4 py-1.5 mb-6 self-center text-center" data-id="element-180">
            <span className="font-sans font-bold text-navy text-[11px] uppercase tracking-[1.5px]" data-id="element-181">
              Para quien ya tiene una vida construida y no quiere quedarse atrás
            </span>
          </div>

          <h1 className="text-[34px] md:text-5xl font-serif font-bold text-navy leading-[1.15] max-w-[560px]" data-id="element-182">
            ¿Cuántas veces dijiste que sí con la cabeza cuando alguien mencionó
            la IA... sin entender nada de lo que dijo?
          </h1>

          <p className="text-base md:text-lg font-sans text-[#4A4A4A] leading-[1.75] max-w-[500px] mt-5" data-id="element-183">
            Sin programar. Sin cursos técnicos. Sin jerga que nadie te traduce.
          </p>

          <p className="text-base md:text-[17px] font-sans italic text-navy leading-[1.75] max-w-[500px] mt-4" data-id="element-184">
            Historias reales de personas que tampoco lograban descifrar qué era
            la IA — y descubrieron cómo transformó su vida.
          </p>

          <p className="text-base md:text-lg font-sans font-medium text-[#4A4A4A] leading-[1.75] max-w-[500px] mt-3" data-id="element-185">
            Seis personas. Una mesa. Tu silla ya está puesta.
          </p>

          <p className="text-[14px] font-sans text-gold mt-4 tracking-wide self-center" data-id="element-186">
            100 páginas &middot; 6 historias reales &middot; PDF inmediato
            &middot; Sin tecnicismos
          </p>

          <div className="mt-6 w-full flex flex-col items-center gap-1" data-id="element-187">
            <div className="flex items-baseline gap-2" data-id="element-188">
              <span className="text-[13px] font-sans text-[#888888]" data-id="element-189">
                Valor real:
              </span>
              <span className="text-[20px] font-serif text-[#999999] line-through" data-id="element-190">
                $25.00
              </span>
            </div>
            <div className="flex items-baseline gap-2" data-id="element-191">
              <span className="text-[13px] font-sans text-[#888888]" data-id="element-192">
                Para que lo tengas hoy:
              </span>
              <span className="text-[40px] md:text-[48px] font-serif font-bold text-navy" data-id="element-193">
                $12.97
              </span>
            </div>
          </div>

          <motion.a href="#offer" whileHover={{
          scale: 1.02,
          filter: 'brightness(0.92)'
        }} whileTap={{
          scale: 0.98
        }} className="mt-5 bg-burnt text-white font-sans font-bold text-[17px] rounded-lg py-[18px] px-[44px] shadow-[0_4px_20px_rgba(230,126,34,0.35)] transition-all duration-200 w-full sm:w-auto inline-block text-center no-underline self-center" data-id="element-194">
            Sí, esa silla es mía &rarr;
          </motion.a>

          <p className="text-[11px] font-sans text-[#999999] mt-2.5" data-id="element-195">
            Pago único &middot; PDF inmediato &middot; Sin suscripciones
            &middot; Sin renovaciones &middot; Si no te cambia la perspectiva,
            te devolvemos el dinero.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 40
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative flex justify-center lg:justify-end" data-id="element-196">
          <div className="relative w-full max-w-lg" data-id="element-197">
            <img src="https://cdn.magicpatterns.com/uploads/54yaqCFFJWvHdkhDYWhqbC/Imegen_Ebook_-_Marta,_Don_Raul_y_La_Inteligencia_Artificial-D.png" alt="Marta, Don Raúl y la Inteligencia Artificial - Bundle Mockup" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-198" />
          </div>
        </motion.div>
      </div>
    </section>;
}